module.exports = __webpack_public_path__ + "img/celts-empire.d5677281.png";